import(/* webpackMode: "eager" */ "/vercel/path0/app/(dashboard)/blocks/page.tsx");
